export const speedOptions = [
  {
    val: 1,
    label: "1.0x",
    description: "speed_control.normal_speed_description",
  },
  { val: 1.25, label: "1.25x" },
  { val: 1.5, label: "1.5x" },
  { val: 2, label: "2.0x" },
];
